var map = {
	"./symbol_0.png": "f9210",
	"./symbol_1.png": "cae2",
	"./symbol_10.png": "6e7a",
	"./symbol_11.png": "b4f8",
	"./symbol_2.png": "e214",
	"./symbol_3.png": "e194",
	"./symbol_4.png": "bd22",
	"./symbol_5.png": "12d3",
	"./symbol_6.png": "005d",
	"./symbol_7.png": "3021",
	"./symbol_8.png": "d2d2",
	"./symbol_9.png": "7a73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bfa";